/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_ZaloInputs */

const vi_shop_contact_zalo = /** @type {(inputs: Shop_Contact_ZaloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo (SĐT hoặc link OA)`)
};

/**

* @param {Shop_Contact_ZaloInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_zalo = /** @type {((inputs?: Shop_Contact_ZaloInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_ZaloInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_zalo(inputs)
});